import { render, staticRenderFns } from "./research-questions-add.vue?vue&type=template&id=80d63dea&"
import script from "./research-questions-add.vue?vue&type=script&lang=js&"
export * from "./research-questions-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80d63dea')) {
      api.createRecord('80d63dea', component.options)
    } else {
      api.reload('80d63dea', component.options)
    }
    module.hot.accept("./research-questions-add.vue?vue&type=template&id=80d63dea&", function () {
      api.rerender('80d63dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/content-manage/research-questions/research-questions-add.vue"
export default component.exports